import React, { useEffect, useRef, useState } from "react"
import { animateScroll } from "react-scroll"
import classnames from "@utils/classnames"
import Button from "@components/button"
import Video from "@components/video"
import FrameBorder from "@components/frameBorder"
import isMobile from "is-mobile"
import styles from "./introVideo.module.scss"

import logoImg from "@images/logo.png"
import playImg from "@images/play.png"
import logosImg from "@images/logos-top.png"
import videoAsset from "@images/video.mp4"
import videoBgAsset from "@images/bg.mp4"

const IntroVideo = () => {
  const isForcedScrolling = useRef(false)
  // useEffect(() => {
  //   const mousewheelevt = /Firefox/i.test(navigator.userAgent)
  //     ? "DOMMouseScroll"
  //     : "mousewheel"
  //   window.addEventListener(
  //     mousewheelevt,
  //     e => {
  //       const scrollTop = window.document.documentElement.scrollTop
  //       const winHeight = window.innerHeight
  //       const delta = e.detail ? e.detail : e.deltaY
  //       if (scrollTop < winHeight) {
  //         // if (isForcedScrolling.current) {
  //         //   console.log("prevent wheel")
  //         // }
  //         if (!isForcedScrolling.current && delta > 0) {
  //           console.log("will scroll")
  //           isForcedScrolling.current = true
  //           setTimeout(() => {
  //             console.log("start scroll!")
  //             animateScroll.scrollTo(winHeight)
  //           }, 300)
  //         }
  //       }
  //     },
  //     { passive: false }
  //   )
  //   window.addEventListener(
  //     "scroll",
  //     e => {
  //       const scrollTop = window.document.documentElement.scrollTop
  //       const winHeight = window.innerHeight
  //       if (scrollTop < winHeight) {
  //       } else {
  //         console.log("unlock scroll")
  //         isForcedScrolling.current = false
  //       }
  //     },
  //     { passive: false }
  //   )
  // }, [])
  const video = useRef(null)
  const bgVideo = useRef(null)
  const [played, setPlayed] = useState(false)
  const [isSupportBgVideo, setIsSupportBgVideo] = useState(false)
  const videoEndedEvent = () => {
    setPlayed(false)
  }

  useEffect(() => {
    setIsSupportBgVideo(!isMobile())
  }, [])

  useEffect(() => {
    if (played) {
      video.current.addEventListener("ended", videoEndedEvent)
    }
    return () => {
      if (video.current) {
        video.current.removeEventListener("ended", videoEndedEvent)
      }
    }
  }, [played])

  useEffect(() => {
    if (typeof window.WeixinJSBridge === "undefined") {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          bgVideo.current && bgVideo.current.play()
        },
        false
      )
    } else {
      window.WeixinJSBridge.invoke(
        "getNetworkType",
        {},
        function(e) {
          bgVideo.current && bgVideo.current.play()
        },
        false
      )
    }
  }, [])

  return (
    <div className={styles.header}>
      <div className={styles.inner}>
        {played && (
          <div className={styles.video}>
            <Button
              className={styles.close}
              onClick={() => {
                setPlayed(false)
              }}
            >
              <span>&times;</span>
            </Button>
            <div className={styles.videoTip}>
              请使用浏览器横屏观看视频以获得最好的体验
            </div>
            <Video inline ref={video}>
              <source src={videoAsset} type="video/mp4" />
            </Video>
          </div>
        )}
        {!played && (
          <>
            <div className={styles.headerBg}>
              {isSupportBgVideo && (
                <Video inline ref={bgVideo} autoPlay loop muted>
                  <source src={videoBgAsset} type="video/mp4" />
                </Video>
              )}
            </div>

            <div className={styles.content}>
              <img src={logoImg} alt="logo" className={styles.logo} />
              <Button
                className={styles.explore}
                onClick={() => {
                  setPlayed(true)
                  setTimeout(() => {
                    if (video.current) {
                      video.current.play()
                    }
                  }, 300)
                }}
              >
                <img className={styles.play} src={playImg} />
              </Button>
            </div>
            <div className={styles.logos}>
              <img src={logosImg} alt="logos" />
            </div>
            <FrameBorder className={styles.frameBorder} />
            <Button
              onClick={() => {
                window.scrollTo(0, window.innerHeight + 100)
              }}
              className={classnames(styles.scrollTip)}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default IntroVideo
